import { AxiosResponse } from 'axios';
import { jobBoardAPI } from './base';
import { CreateEmployeeDTO } from 'data/from-data/create-employee-form.data';
import { Employee, Role } from 'data/users';

const employee = {
  get: 'employee',
  create: 'employee',
  getEmployee: '/employee/:{id}',
  getEmployeeRoles: '/roles/roles',
  getMe: '/auth/me',
  uploadProfileImage: '/auth/upload-profile-image'
};
export const GET_EMPLOYEES_QUERY = async (): Promise<
  AxiosResponse<Employee[]>
> => {
  return (await jobBoardAPI.get(employee.get)).data;
};

export const CREATE_EMPLOYEE = async (
  employeeDto: CreateEmployeeDTO
): Promise<AxiosResponse<Employee>> =>
  jobBoardAPI.post(employee.create, employeeDto);

export const GET_EMPLOYEE = async (
  employeeId: string
): Promise<AxiosResponse<Employee>> => {
  const endpoint = employee.getEmployee.replace(':{id}', employeeId);
  return (await jobBoardAPI.get(endpoint)).data;
};

export const UPDATE_EMPLOYEE = async ({
  employeeId,
  formData
}: {
  employeeId?: string;
  formData?: CreateEmployeeDTO;
}): Promise<AxiosResponse<Employee>> => {
  const endpoint = `/employee/${employeeId}`;

  return jobBoardAPI.patch(endpoint, formData);
};

export const DELETE_EMPLOYEE = async (
  employeeId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/employee/${employeeId}`;
  return jobBoardAPI.delete(endpoint);
};

export const GET_EMPLOYEE_ROLES = async (): Promise<Role[]> => {
  const response = await jobBoardAPI.get(employee.getEmployeeRoles);
  return response.data.data;
};

export const GET_ME = async (): Promise<AxiosResponse<Employee>> => {
  const response = await jobBoardAPI.get(employee.getMe);
  return response.data;
};

export const UPLOAD_PROFILE_IMAGE = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await jobBoardAPI.post(
    employee.uploadProfileImage,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
  return response.data;
};
